import React from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import { ExperienceCard } from "../ExperienceCard";
import { AcademicInfoCard } from "../AcademicInfoCard";

export const CreateNewBlankModal = ({ open, onClose, data }) => {
  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "900px",
          minWidth: "300px",
        },
      }}
    >
      <DialogTitle textAlign="center">
        {data.type === "courses" ? "Cursos" : "Experiências"}
      </DialogTitle>
      <DialogContent
        sx={{ width: "fit-content", display: "flex", justifyContent: "center" }}
      >
        <Stack
          sx={{
            padding: "10px 0",
            minWidth: "300px",
            gap: "1.5rem",
            display: "flex",
            alignItems: "center",
          }}
        >
          {data.data.map((item) =>
            data.type === "courses" ? (
              <AcademicInfoCard course={item} hideActions />
            ) : (
              <ExperienceCard experience={item} hideActions />
            ),
          )}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button sx={{ color: "#104467" }} onClick={onClose}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
